export enum LocaleType {
  DE = 'de',
  EN = 'en',
}
